import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../../common/layout/Navbar";
import { APIProvider } from "@vis.gl/react-google-maps";
import { LicenseTypes } from "../../../../utils/Enum.types";
import MapsView from "./MapsView";
import {
  GetDataForMapsData,
  GetGetVmsBoardDetailsVars,
  GetVmsBoardDetailsResult,
} from "./queries/types";
import { useLazyQuery } from "@apollo/client";
import { GetVmsBoardDetails } from "./queries/queries";
import useUrlParams from "../../../../customHooks/useUrlParams";
import useToken from "../../../../customHooks/useToken";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Loading from "../../../../images/Loading.gif";
import CheckConnectivity from "./CheckConnectivity";
import { MapAutocomplete } from "../maps/MapAutocomplete";
import RightArrow from "../../../../images/ArrowRight.svg";
import Input from "../../../../stories/Input/Input";
interface Props {
  NavType: LicenseTypes;
}
const VMSBoardsIndex = ({ NavType }: Props) => {
  const { customer_id } = useUrlParams();
  const { handleToken } = useToken();

  const clusterer = useRef<MarkerClusterer | null>(null);

  const [items, setItems] = useState<GetVmsBoardDetailsResult[]>([]);
  const [searchCoordinates, setSearchCoordinates] = useState("");
  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null);
  const [GetVmsBoards, { data, loading }] = useLazyQuery<
    GetDataForMapsData,
    GetGetVmsBoardDetailsVars
  >(GetVmsBoardDetails, {
    pollInterval: 20000,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await handleToken();
        if (token && customer_id) {
          const { data } = await GetVmsBoards({
            variables: {
              customerID: customer_id,
              token,
            },
          });

          if (data && data.GetVmsBoardDetails) {
            setItems(data.GetVmsBoardDetails);
          } else {
            setItems([]);
          }
        } else {
          setItems([]);
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };

    fetchData();
  }, [customer_id]);

  return (
    <>
      <Navbar NavType={NavType} />
      <APIProvider apiKey={process.env.React_App_MAP!}>
        {loading ? (
          <div className="loading-container">
            <img src={Loading} alt="loading" className="loading-gif" />
          </div>
        ) : (
          <div className="vms-boards">
            <MapsView
              items={items}
              clusterer={clusterer}
              selectedPlace={selectedPlace}
              searchCoordinates={searchCoordinates}
            />

            <div className="vms-boards__search">
              <div className="maps__search">
                <Input
                  id="data_search"
                  placeholder="Lat,Lng..."
                  onChange={(e) => {
                    setSelectedPlace(null);
                    setSearchCoordinates(e.target.value);
                  }}
                />
              </div>

              <MapAutocomplete onPlaceSelect={setSelectedPlace} />
            </div>
            <CheckConnectivity />
          </div>
        )}
      </APIProvider>
    </>
  );
};

export default VMSBoardsIndex;
